import request from "@/utils/http"
import store from "@/store"
import { Message } from "element-ui"

export function syncData(data) {
  if (store.getters.isTemplateMode) {
    Message.warning("预览状态无法操作")
    return Promise.reject("预览状态无法操作")
  }
  return request.post(`/sheet/batch/syncData`, data).commonDeal()
}

export function getSyncDataTaskList(inApp, page, size, appId) {
  return request
    .post(`/syncDataTask/getSyncDataTaskList`, null, { params: { inApp, page, size, appId } })
    .commonDeal()
}

export function retrySyncDataTask(taskId) {
  return request.post(`/syncDataTask/retrySyncDataTask`, {}, { params: { taskId } }).commonDeal()
}
